import React, { Fragment, PureComponent } from 'react';
import { AJAX_REQUEST, CURRENCY_FORMAT, SET_STORAGE, GET_STORAGE, REMOVE_STORAGE } from "../../../Constants/AppConstants";
import { NavLink } from 'react-router-dom';
import $ from "jquery";
import history from "../../../history";
import SubscriptionCartProductList from './SubscriptionCartProductList';
import AlertWrapperSuccess from '../../Common/AlertWrapperSuccess';
import AlertWrepper from "../../Common/AlertWrapper";
import { Row, Col } from "react-bootstrap";
import Parser from 'html-react-parser';

class SubscriptionCart extends PureComponent {
    constructor(props) {
        super(props)
        const settings = GET_STORAGE('settings') ? JSON.parse(GET_STORAGE('settings')) : {};
        this.state = {
            settings: settings,
            taxStatus: settings.tax_status || 0,
            subscription_id: parseInt(this.props.match.params.id),
            products: [],
            currentItems: [],
            shipping_method: "",
            shipping_charge: 0,
            address_1: "",
            postcode: "",
            city: "",
            state: "",
            country: "",
            loading: true,
            saving: false,
            isLoading: false,
            success_alert_wrapper_show: false,
            shipping_fee: 0,
            product_discount: [],
            subscription_detail: [],
            is_custom_bundle: '',
            combinedItems: [],
            appliedDiscount: 0,
            subscriptionDiscountFactor: 0,
            is_amount_based: 0,
            subscription_tax_amount: 0,
            subscription_tax_info: '',
            shipping_cost: 0,
        }
        document.title = "Subscription Cart-Prestige Labs";
    }

    componentDidMount() {
        document.getElementById("scrollTop").scrollIntoView() // Scroll to Top
        this.getSubscriptionProducts();
    }

    getSubscriptionProducts = () => {
        let cart_items = [];
        let newSubsItems = [];
        let currentSubsItems = [];

        if (GET_STORAGE('subscriptionItem')) {
            newSubsItems = JSON.parse(GET_STORAGE('subscriptionItem'))

            if (newSubsItems.length < 0 || newSubsItems == '') {
                history.push("/my-account/related-subscription/" + this.state.subscription_id);
            }

            newSubsItems.forEach(function (item, key) {
                let newItem = {
                    cart_product_id: item.subs_product_id,
                    cart_product_name: item.subs_product_name,
                    cart_image: item.subs_image,
                    cart_variation_id: item.subs_variation_id,
                    cart_variation_name: item.subs_variation_name,
                    cart_sale_price: 0,
                    subscription: "yes",
                    cart_subscription_msg: item.subs_subscription_msg,
                    cart_discount_price: item.subs_discount_price,
                    quantity: item.quantity,
                }
                cart_items.push(newItem);
            });
        }

        // Get existing order details
        const data = { subscription_id: this.state.subscription_id }
        AJAX_REQUEST("POST", "subscription/getDetails", data).then(results => {
            if (parseInt(results.response.code) === 1000) {
                currentSubsItems = results.response.data.subscription.items;
                let shipping_address = results.response.data.shipping_address;
                let product_discount = results.response.data.product_discount;
                let subscription_detail = results.response.data.subscription_detail;
                let is_custom_bundle = results.response.data.is_custom_bundle;

                currentSubsItems.forEach(function (item, key) {
                    let newItem = {
                        cart_product_id: item.product_id,
                        cart_product_name: item.name,
                        cart_image: item.product_thumbnail,
                        cart_variation_id: item.variation_id,
                        cart_variation_name: "",
                        cart_sale_price: 0,
                        subscription: "yes",
                        cart_subscription_msg: "",
                        cart_discount_price: item.total_price,
                        quantity: item.quantity,
                    }
                    cart_items.push(newItem);
                });

                this.setState({
                    cart_items: cart_items,
                    products: newSubsItems,
                    currentItems: currentSubsItems,

                    shipping_charge: parseFloat(String(results.response.data.subscription.shipping_charge).replace(/,/g, '')) || 0,
                    shipping_method: results.response.data.subscription.shipping_method,
                    shipping_cost: parseFloat(String(results.response.data.subscription.shipping_charge).replace(/,/g, '')) || 0,

                    address_1: shipping_address.shipping_address_1 || shipping_address.street_address,
                    postcode: shipping_address.zip,
                    city: shipping_address.city,
                    state: shipping_address.state,
                    country: shipping_address.country,
                    payment_method : results.response.data.subscription.payment_method,
                    product_discount,
                    subscription_detail,
                    is_custom_bundle,
                    is_amount_based: results.response.data.subscription.is_amount_based,

                    loading: false
                }, () => {
                    this.handleCustomBundleDiscount();
                    if (this.state.is_custom_bundle != 1) {
                        this.refreshShippingFeeAndTax();
                    }
                });
            }
        });
    }

    computeSubTotal = () => {
        const isCustomBundleDiscountEnabled = this.state.settings?.custom_bundle_discount_settings === 'enable';
        let subTotal = 0;

        this.state.products.forEach((product) => {
            if (isCustomBundleDiscountEnabled) {
                if (this.state.is_custom_bundle == 1 && product.custom_bundle_discount_price) {
                    subTotal += Number(product.custom_bundle_discount_price) * Number(product.quantity);
                } else {
                    subTotal += Number(product.subs_discount_price) * Number(product.quantity);
                }
            } else if (this.state.is_custom_bundle == 1 && product.custom_bundle_discount_price) {
                subTotal += Number(product.custom_bundle_discount_price) * Number(product.quantity);
            } else {
                subTotal += Number(product.subs_discount_price) * Number(product.quantity);
            }
        });

        this.state.currentItems.forEach((product) => {
            if (isCustomBundleDiscountEnabled && this.state.is_custom_bundle == 1 && product.custom_bundle_discount_price) {
                subTotal += Number(product.custom_bundle_discount_price) * Number(product.quantity);
            } else {
                const lineAmount = product.subs_discount_price || product.total_price || 0;
                subTotal += parseFloat(String(lineAmount).replace(/,/g, '')) || 0;
            }
        });

        return subTotal;
    }

    computeCanadaShippingFee = (subTotal) => {
        if (parseInt(this.state.country, 10) !== 38) {
            return 0;
        }
        let shipping_fee = 0;
        const settings_data = this.state.settings;
        settings_data?.canada_shipping_settings?.forEach((setting) => {
            const minAmount = Number(setting.min_order_amount);
            const maxAmount = Number(setting.max_order_amount);
            const percentage = Number(setting.percentage);
            if (subTotal >= minAmount && subTotal <= maxAmount) {
                shipping_fee = (subTotal * percentage) / 100;
            }
        });
        return shipping_fee;
    }

    parseMoney = (value) => {
        if (value === undefined || value === null || value === '') {
            return 0;
        }
        return parseFloat(String(value).replace(/,/g, '')) || 0;
    }

    mergeCartItemsForTax = (cart_items) => {
        const merged = {};

        cart_items.forEach((item) => {
            const variationId = String(item.cart_variation_id);
            const qty = parseInt(item.quantity, 10) || 1;
            const unitPrice = this.parseMoney(item.cart_discount_price);
            const bundlePrice = this.parseMoney(item.custom_bundle_discount_price) || unitPrice;

            if (!merged[variationId]) {
                merged[variationId] = {
                    ...item,
                    quantity: qty,
                    cart_discount_price: unitPrice,
                    custom_bundle_discount_price: bundlePrice,
                };
                return;
            }

            merged[variationId].quantity = (parseInt(merged[variationId].quantity, 10) || 0) + qty;
            if (unitPrice > 0) {
                merged[variationId].cart_discount_price = unitPrice;
            }
            if (bundlePrice > 0) {
                merged[variationId].custom_bundle_discount_price = bundlePrice;
            }
        });

        return Object.values(merged);
    }

    buildCartItemsForTax = () => {
        const isCustomBundle = this.state.is_custom_bundle == 1;
        const isCustomBundleDiscountEnabled = this.state.settings?.custom_bundle_discount_settings === 'enable';
        const cart_items = [];

        this.state.products.forEach((item) => {
            let unitPrice = this.parseMoney(item.subs_discount_price) || this.parseMoney(item.sale_price);
            if (isCustomBundle && item.custom_bundle_discount_price) {
                unitPrice = this.parseMoney(item.custom_bundle_discount_price);
            } else if (isCustomBundleDiscountEnabled && item.custom_bundle_discount_price) {
                unitPrice = this.parseMoney(item.custom_bundle_discount_price);
            }
            if (unitPrice <= 0) {
                return;
            }
            cart_items.push({
                cart_product_id: item.subs_product_id,
                cart_product_name: item.subs_product_name,
                cart_image: item.subs_image,
                cart_variation_id: item.subs_variation_id,
                cart_variation_name: item.subs_variation_name || '',
                cart_sale_price: isCustomBundle ? unitPrice : 0,
                subscription: 'yes',
                cart_subscription_msg: item.subs_subscription_msg || '',
                cart_discount_price: unitPrice,
                custom_bundle_discount_price: this.parseMoney(item.custom_bundle_discount_price) || unitPrice,
                quantity: parseInt(item.quantity, 10) || 1,
            });
        });

        this.state.currentItems.forEach((item) => {
            const lineTotal = this.parseMoney(item.total_price);
            let unitPrice = lineTotal / (parseInt(item.quantity, 10) || 1);
            if (isCustomBundle && item.custom_bundle_discount_price) {
                unitPrice = this.parseMoney(item.custom_bundle_discount_price);
            } else if (isCustomBundleDiscountEnabled && item.custom_bundle_discount_price) {
                unitPrice = this.parseMoney(item.custom_bundle_discount_price);
            }
            if (unitPrice <= 0) {
                return;
            }
            cart_items.push({
                cart_product_id: item.product_id,
                cart_product_name: item.name,
                cart_image: item.product_thumbnail,
                cart_variation_id: item.variation_id,
                cart_variation_name: '',
                cart_sale_price: isCustomBundle ? unitPrice : 0,
                subscription: 'yes',
                cart_subscription_msg: '',
                cart_discount_price: unitPrice,
                custom_bundle_discount_price: this.parseMoney(item.custom_bundle_discount_price) || unitPrice,
                quantity: parseInt(item.quantity, 10) || 1,
            });
        });

        return this.mergeCartItemsForTax(cart_items);
    }

    refreshShippingFeeAndTax = () => {
        const subTotal = this.computeSubTotal();
        const shipping_fee = this.computeCanadaShippingFee(subTotal);
        const cart_items = this.buildCartItemsForTax();
        this.setState({ shipping_fee, cart_items }, () => this.getTax(cart_items));
    }

    handleCustomBundleDiscount = () => {
        const { is_custom_bundle, is_amount_based, products, currentItems, product_discount, subscription_detail } = this.state;
    
        if (is_custom_bundle == 1) {
            let combinedItems = [];
    
            if (products.length > 0) {
                combinedItems = combinedItems.concat(products.map(product => ({ ...product, type: 'products' })));
            }
    
            if (currentItems.length > 0) {
                combinedItems = combinedItems.concat(currentItems.map(product => ({ ...product, type: 'currentItems' })));
            }
    
            const isCustomBundleDiscountEnabled = this.state.settings.custom_bundle_discount_settings === 'enable';            
            if (is_amount_based == 1) {
                this.handleCustomBundleByPriceCalculation(combinedItems, subscription_detail);
            } else if (isCustomBundleDiscountEnabled) {
                this.handleCustomBundleByPriceCalculation(combinedItems, subscription_detail);
            } else {
                this.handleQuantityBasedCalculation(combinedItems, product_discount, subscription_detail);
            }
        }
    }

    combineItems = (products, currentItems) => [
        ...products.map(product => ({ ...product, type: 'products' })),
        ...currentItems.map(product => ({ ...product, type: 'currentItems' }))
    ];

    handleCustomBundleByPriceCalculation = (combinedItems, subscription_detail) => {
        let cartSubtotal = combinedItems.reduce((total, product) => {
            return total + parseFloat(product.sale_price) * product.quantity;
        }, 0);

        const subscriptionDiscountFactor = parseFloat(subscription_detail.subscription_save_percentage_ds || 0) / 100;
        
        let subscriptionDiscountedSubtotal = 0;
        combinedItems.forEach(product => {
            const productTotal = parseFloat(product.sale_price) * product.quantity;
            subscriptionDiscountedSubtotal += productTotal * (1 - subscriptionDiscountFactor);
        });
   
        let appliedDiscount = 0;
        let matchingDiscount = null;
        const orderAmountDiscount = JSON.parse(GET_STORAGE('orderAmountDiscount') || '[]');
        
        for (let discount of orderAmountDiscount) {
            const minAmount = parseFloat(discount.min_amount);
            const maxAmount = parseFloat(discount.max_amount);
            if (subscriptionDiscountedSubtotal >= minAmount && subscriptionDiscountedSubtotal <= maxAmount) {
                matchingDiscount = discount;
                break;
            }
        }
        if (matchingDiscount) {
            appliedDiscount = parseFloat(matchingDiscount.discount);
        }

        const [updatedProducts, updatedCurrentItems] = combinedItems.reduce(
            ([productsArr, currentArr], product) => {
                const productId = product.product_id || product.subs_product_id;
                let finalPrice = parseFloat(product.sale_price);
                let discount = 0;

                const subscriptionOnlyDiscount = finalPrice * subscriptionDiscountFactor;
                const priceAfterSubscriptionDiscount = finalPrice - subscriptionOnlyDiscount;
                product.subscription_discounted_price = priceAfterSubscriptionDiscount.toFixed(2);
                let finalDiscountedPrice = priceAfterSubscriptionDiscount;
                
                if (matchingDiscount && subscriptionDiscountedSubtotal > 0) {
                    const productTotal = priceAfterSubscriptionDiscount * product.quantity;
                    const productDiscountAmount = (productTotal / subscriptionDiscountedSubtotal) * appliedDiscount;
                    finalDiscountedPrice = (productTotal - productDiscountAmount) / product.quantity;
                }

                product.custom_bundle_discount_price = finalDiscountedPrice.toFixed(2);

                if (product.type === 'products') {
                    productsArr.push(product);
                } else {
                    currentArr.push(product);
                }
                return [productsArr, currentArr];
            },
            [[], []]
        );

        this.setState({
            products: updatedProducts,
            currentItems: updatedCurrentItems,
            combinedItems,
            appliedDiscount,
            subscriptionDiscountFactor
        }, () => this.refreshShippingFeeAndTax());
    }

    handleQuantityBasedCalculation = (combinedItems, product_discount, subscription_detail) => {
        let cartSubtotal = 0;
        let ProductTotalQuantity = 0;
        combinedItems.forEach(product => {
                const productId = product.product_id || product.subs_product_id;
                if (productId !== '48') {
                    cartSubtotal += parseFloat(product.sale_price) * product.quantity;
                    ProductTotalQuantity += parseInt(product.quantity, 10);
                }
            });
    
        const maxQuantity = Math.max(...product_discount.map(d => parseInt(d.product_qty, 10)));
        const matchQty = ProductTotalQuantity > maxQuantity ? maxQuantity : ProductTotalQuantity;
        const matchingDiscount = product_discount.find(d => parseInt(d.product_qty, 10) === matchQty);

        let appliedDiscount = matchingDiscount ? matchingDiscount.discount : 0;
        let totalDiscountAmt = (appliedDiscount / 100) * cartSubtotal;
        const discountFactor = parseFloat(subscription_detail.subscription_save_percentage_ds || 0) / 100;
    
            if (matchingDiscount) {
            const [updatedProducts, updatedCurrentItems] = combinedItems.reduce(
                ([productsArr, currentArr], product) => {
                    const productId = product.product_id || product.subs_product_id;
                    let discountedPrice;
                    if (productId !== '48') {
                        const productTotal = parseFloat(product.sale_price) * product.quantity;
                        const productDiscount = (productTotal / cartSubtotal) * totalDiscountAmt;
                        const discountPerQty = productDiscount / product.quantity;
                        const newSalePrice = product.sale_price - discountPerQty;
                        discountedPrice = newSalePrice * (1 - discountFactor);
                    } else {
                        discountedPrice = product.sale_price * (1 - discountFactor);
                    }
                    product.custom_bundle_discount_price = discountedPrice.toFixed(2);
                    if (product.type === 'products') {
                        productsArr.push(product);
                    } else {
                        currentArr.push(product);
                    }
                    return [productsArr, currentArr];
                },
                [[], []]
            );
                this.setState({
                    products: updatedProducts,
                    currentItems: updatedCurrentItems,
                    combinedItems,
                appliedDiscount,
                subscriptionDiscountFactor: discountFactor
                }, () => this.refreshShippingFeeAndTax());
        } else {
            this.refreshShippingFeeAndTax();
        }
    }

    // Get and calculate tax if applicable (includes tax on recurring shipping + international shipping fee)
    getTax = (cartItemsForTax) => {

        this.setState({
            subscription_tax_amount: 0,
            subscription_tax_info: '',
        })

        const taxEnabled = parseInt(this.state.taxStatus, 10) === 1
            || this.state.settings?.enable_tax === 'yes'
            || this.state.settings?.enable_tax === 1;

        if (taxEnabled) {
            const builtCartItems = this.buildCartItemsForTax();
            const cart_items = (cartItemsForTax && cartItemsForTax.length)
                ? cartItemsForTax
                : (builtCartItems.length ? builtCartItems : this.state.cart_items);

            const isCustomBundle = this.state.is_custom_bundle == 1;
            let taxData = {
                address_1: this.state.address_1,
                postcode: this.state.postcode,
                city: this.state.city,
                state: this.state.state,
                country: this.state.country,
                shipping_fee: Number(this.state.shipping_fee) || 0,
                subscription_shipping_cost: Number(this.state.shipping_cost) || 0,
                is_custom_bundle: isCustomBundle ? 'yes' : 'no',
                cart_items: cart_items
            }
            AJAX_REQUEST("POST", "order/getTax", taxData).then(results => {
                if (parseInt(results.response.code) === 1000 && results.response.data != '') {
                    const taxAmount = parseFloat(results.response.data.subscription_tax_amount) || 0;
                    this.setState({
                        subscription_tax_amount: taxAmount,
                        subscription_tax_info: results.response.data.subscription_tax_info,
                    });
                }
            });
        }
    }

    timeOut = (timedata) => {
        setTimeout(function () {
            this.setState({
                success_alert_wrapper_show: false
            });
        }.bind(this), timedata);
    }

    deleteItem = (e, row_id) => {
        e.preventDefault();
        if (window.confirm("Are you sure want to delete item?")) {
            let subscriptionItem = JSON.parse(GET_STORAGE('subscriptionItem'));
            if (subscriptionItem.splice(row_id, 1)) {
                SET_STORAGE("subscriptionItem", JSON.stringify(subscriptionItem));
                this.getSubscriptionProducts();
                document.querySelector("body").scrollIntoView();
                this.setState({ success_alert_wrapper_show: true });
                this.timeOut(5000);
            }
        }
    }

    onSubmitHandler = (e) => {
        e.preventDefault();

        // Create new items array
        let items = [];
        JSON.parse(GET_STORAGE('subscriptionItem')).forEach(function (item, key) {
            let newItem = {
                product_id: item.subs_product_id,
                variation_id: item.subs_variation_id,
            }
            items.push(newItem);
        });

        let data = {
            subscription_id: this.state.subscription_id,
            subscription_items: items,
            subscription_tax_amount: this.state.subscription_tax_amount,
            subscription_tax_info: this.state.subscription_tax_info,
            shipping_fee: Number(this.state.shipping_fee),
            custom_bundle_items: this.state.combinedItems.map(function (item) {
            const isCustomBundleDiscountEnabled = (GET_STORAGE('custom_bundle_discount_settings') || 'disable') === 'enable';
            return {
                product_id: item.product_id || item.subs_product_id,
                custom_bundle_discount_price: isCustomBundleDiscountEnabled ? item.sale_price : item.custom_bundle_discount_price,
                quantity: item.quantity,
                variation_id: item.variation_id || item.subs_variation_id
            };
            }),
            custom_discount: this.state.appliedDiscount
        }
        this.setState({ isLoading: true, saving: true, });
        AJAX_REQUEST("POST", "subscription/addItem", data).then(results => {
            if (parseInt(results.response.code) === 1000) {
                if(this.state.payment_method == 'paypal') {
                    window.location.href  = results.response.checkoutUrl;
                }else{
                    history.push("/my-account/related-subscription/" + this.state.subscription_id + "?is_subscription_orders_page=1");
                }
                REMOVE_STORAGE("subscriptionItem");
                this.setState({
                    isLoading: false,
                    saving: false,
                });
                
            } else {
                this.setState({
                    error_meg: results.response.message,
                    loading: false,
                    success_alert_wrapper_show: false,
                    saving: false,
                });
            }
        });

    }

    render() {

        let subTotal = this.computeSubTotal();
        return (
            <Fragment>
                {
                    this.state.loading ?
                        <div className="loading container full_page_loader"></div>
                        :
                        <Fragment>
                            <div className="cart_page_container aff_cart_page_container">
                                <form onSubmit={this.onSubmitHandler} id="cartForm" className='w-100'>
                                    <div className="container">
                                        <h2 className="font_24 mb_11 text_black text-uppercase fw_el_semi">Shopping CART</h2>
                                        <nav aria-label="breadcrumb" className="mb_13">
                                            <ol className="breadcrumb cus_breadcrumb pro_breadcrumb cart_breadcrubmb">
                                                <li className="breadcrumb-item font_16 choose_text fw_ar_reg">
                                                    <NavLink to="/">Home</NavLink>
                                                </li>
                                                <li className="breadcrumb-item font_16 choose_text fw_ar_reg" aria-current="page">
                                                    &gt; Shopping Cart
                                                </li>
                                            </ol>
                                        </nav>
                                        <div className="row cart_row">
                                            <Col md={8}>
                                                <div className="cart_left_det">
                                                    {
                                                        (this.state.error_meg) ?
                                                        <AlertWrepper errors_data={Parser(this.state.error_meg)} success_alert_wrapper_show={this.state.success_alert_wrapper_show} />
                                                        :
                                                        null
                                                    }
                                                    <AlertWrapperSuccess errors_data="Subscription item removed successfully" success_alert_wrapper_show={this.state.success_alert_wrapper_show} />
                                                    <h2 className="font_16 mb_11 text_black text-uppercase fw_ar_semi">NEWLY ADDED ITEM(S) {(() => {
                                                        const isCustomBundleDiscountEnabled = this.state.settings?.custom_bundle_discount_settings === 'enable';
                                                        
                                                        if (isCustomBundleDiscountEnabled) {
                                                            return '';
                                                        } else {
                                                            return (this.state.appliedDiscount != 0) ? `(${this.state.appliedDiscount}% OFF)` : '';
                                                        }
                                                    })()}</h2>
                                                    <div className="cart_left_det">
                                                        {
                                                            (this.state.products.length <= 0) ? <div className="cart_pro_list d-flex align-items-center justify-content-center aff_cart_pro_list"><h5 className='m-0 font_16 text_black text-center fw_ar_reg'>No Record Found</h5></div> :
                                                                this.state.products.map(function (product, key) {
                                                                    // Added item delete methos
                                                                    product.deleteItem = this.deleteItem;
                                                                    product.row_id = key;

                                                                    return (
                                                                        <SubscriptionCartProductList 
                                                                            key={key} 
                                                                            product={product} 
                                                                            settings={this.state.settings}
                                                                            subscriptionDiscountFactor={this.state.subscriptionDiscountFactor} 
                                                                        />
                                                                    )
                                                                }.bind(this))
                                                        }
                                                    </div>
                                                    <h2 className="font_16 mb_11 text_black text-uppercase fw_ar_semi">CURRENT SUBSCRIPTION ITEM(S)</h2>
                                                    <div className="cart_left_det">
                                                        {
                                                            (this.state.currentItems.length <= 0) ? <div className="cart_pro_list d-flex align-items-center justify-content-center aff_cart_pro_list"><h5 className='m-0 font_16 text_black text-center fw_ar_reg'>No Record Found</h5></div> :
                                                                this.state.currentItems.map(function (product, key) {
                                                                    product.subs_product_name = product.name;
                                                                    product.subs_discount_price = product.total_price;
                                                                    product.subs_image = product.product_thumbnail;

return (
                                                                        <SubscriptionCartProductList 
                                                                            key={key} 
                                                                            deleteItem="false" 
                                                                            product={product} 
                                                                            settings={this.state.settings}
                                                                            subscriptionDiscountFactor={this.state.subscriptionDiscountFactor} 
                                                                        />
                                                                    )
                                                                }.bind(this))
                                                        }
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="cart_rgt_blk white_bg">
                                                    <ul className="pro_cart_det">
                                                        <li className="d-flex align-items-center flex-wrap mb_7">
                                                            <span className="total_span let_spa_2 d-block font_14 fw_ar_reg">Sub Total</span>
                                                            <span className="price_span let_spa_2 text-right d-block font_14 fw_ar_reg">{CURRENCY_FORMAT(subTotal)}</span>
                                                        </li>
                                                        <li className="d-flex align-items-center flex-wrap mb_4">
                                                            <span className="total_span let_spa_2 d-block font_14 fw_ar_reg">Shipping Cost</span>
                                                            <span className="price_span let_spa_2 text-right d-block font_14 fw_ar_reg">{CURRENCY_FORMAT(this.state.shipping_charge)}</span>
                                                        </li>
                                                        <li className="d-flex align-items-center flex-wrap mb_3">
                                                            <span className="d-block let_spa_2 font_12 fw_ar_reg text_default">{this.state.shipping_method}</span>
                                                        </li>
                                                        {this.state.country == 38 && (
                                                            <Fragment>
                                                                <li className="d-flex align-items-center flex-wrap mb_4">
                                                                    <span className="total_span let_spa_2 d-block font_14 fw_ar_reg">International Shipping Fee</span>
                                                                    <span className="price_span let_spa_2 text-right d-block font_14 fw_ar_reg">
                                                                        {CURRENCY_FORMAT(this.state.shipping_fee)}
                                                                    </span>
                                                                </li>
                                                            </Fragment>
                                                        )}
                                                        {
                                                            (this.state.taxStatus == 1) ?
                                                                <Fragment>
                                                                    <li className="d-flex align-items-center flex-wrap mb_4">
                                                                        <span className="total_span let_spa_2 d-block font_14 fw_ar_reg">Tax</span>
                                                                        <span className="price_span let_spa_2 text-right d-block font_14 fw_ar_reg">{CURRENCY_FORMAT(this.state.subscription_tax_amount)}</span>
                                                                    </li>
                                                                </Fragment>
                                                                : null
                                                        }
                                                        <li className="d-flex align-items-center flex-wrap mb_26">
                                                            <span className="total_span let_spa_2 d-block font_16 fw_ar_bold">Total</span>
                                                            <span className="price_span let_spa_2 text-right d-block font_16 fw_ar_bold">
                                                                {
                                                                    CURRENCY_FORMAT(Number(subTotal) + Number(this.state.shipping_charge) + Number(this.state.subscription_tax_amount) + Number(this.state.shipping_fee))
                                                                }
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <button disabled={this.state.isLoading} className="w-100 d-flex justify-content-center shop_more take_quiz_btn font_16 text_white fw_ar_reg">{this.state.saving ? "Please Wait..." : "Confirm and Proceed"}</button>
                                                </div>
                                            </Col>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </Fragment>
                }
            </Fragment>
        );
    }
}

export default SubscriptionCart;
